import AssessmentApis from '../../apis/aeAssessment';
import { ASSESSMENT_QUES, SUBMIT_ASSESSMENT } from '../../types';
import { showToast } from '../aeToast';
import { signOut } from '../auth';

import { ERROR_MSG, ERROR_MSG_401 } from '../../../constants';

export const getAssessmentQues = (roll_name) => (dispatch) => {
  const callApi = async () => {
    try {
      const res = await AssessmentApis.searchAssessmentQues(roll_name);

      if (res.status === 500) {
        throw res;
      }

      if (res.status === 401) {
        dispatch(showToast('error', ERROR_MSG_401));
        dispatch(signOut());
      }

      const res_data = await res.json();

      if (!res.ok) {
        throw res_data;
      } else {
        //   resolve(res_data);

        dispatch({ type: `${ASSESSMENT_QUES}_success`, payload: res_data });
      }
    } catch (err) {
      // reject(err);

      const payload = err && err.message ? err : { message: ERROR_MSG };

      dispatch({ type: `${ASSESSMENT_QUES}_failed`, payload });
    }
  };

  dispatch({ type: `${ASSESSMENT_QUES}_started` });

  return Promise.resolve(callApi());
};

export const submitAssessment = (payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await AssessmentApis.submitAssessment(payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          resolve(res_data);
          dispatch({ type: `${SUBMIT_ASSESSMENT}_success`, payload: res_data });
        }
      } catch (err) {
        reject(err);
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${SUBMIT_ASSESSMENT}_failed`, payload });
      }
    };

    dispatch({ type: `${SUBMIT_ASSESSMENT}_started` });

    return Promise.resolve(callApi());
  });
